import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function WaveVariantD({ size, color }: IconProps) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={size || '24px'}
      height={size || '30px'}
      viewBox="0 0 24 30"
      xmlSpace="preserve"
    >
      <title>WaveVariantD</title>
      <rect x="0" y="0" width="4" height="20" fill={color ?? 'currentColor'}>
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="7" y="0" width="4" height="20" fill={color ?? 'currentColor'}>
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.2s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="14" y="0" width="4" height="20" fill={color ?? 'currentColor'}>
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.4s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
}
